import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Instance from 'highcharts'
import HighCharts from 'highcharts-react-official'
import InfoLabel from '../Labels/InfoLabel'
import { Box, GlobalStyle, Root } from './LineChart.styles'

Instance.setOptions({
  lang: { numericSymbols: ['K', 'M', 'MM', 'MM'] }
})

/**
 * The LineChart's component.
 */
const LineChart = props => {
  const { categories, data, id, labels, tooltipFormatter } = props
  const theme = useTheme()
  const options = {
    accessibility: { enabled: false },
    allowHTML: true,
    chart: { type: 'line' },
    plotOptions: {
      line: { lineWidth: 4 },
      series: {
        animation: false,
        marker: {
          fillColor: theme.palette.brand.white,
          lineColor: null,
          lineWidth: 2,
          radius: 5
        }
      }
    },
    series: data,
    title: { text: '' },
    tooltip: {
      borderWidth: 1,
      formatter: tooltipFormatter,
      shadow: true
    },
    xAxis: {
      categories,
      endOnTick: false,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      max: 11,
      min: 0,
      startOnTick: false
    },
    yAxis: {
      gridLineDashStyle: 'ShortDash',
      title: { text: '' }
    }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
        <Box mb={2}>
          {labels.map(label => (
            <InfoLabel color={label.color} key={label.name} label={label.name} margin="0 50px 20px 0" />
          ))}
        </Box>
      </Root>
    </>
  )
}

LineChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.arrayOf(PropTypes.number),
      color: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      month: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalAmount: PropTypes.arrayOf(PropTypes.number)
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  tooltipFormatter: PropTypes.func.isRequired
}

export default LineChart
